const BUILD_DEFAULTS = {
    azureClientId: import.meta.env.VITE_AZURE_CLIENT_ID || '',
    azureTenantId: import.meta.env.VITE_AZURE_TENANT_ID || '',
    classifierApiUrl: (import.meta.env.VITE_CLASSIFIER_API_URL || 'http://localhost:3010').replace(/\/$/, ''),
    validationSlaMinutes: import.meta.env.VITE_VALIDATION_SLA_MINUTES || '60',
};
let cached = null;
/** Sync read — available after loadRuntimeConfig() in main.tsx. */
export function getRuntimeConfig() {
    return cached ?? { ...BUILD_DEFAULTS };
}
/**
 * Load /config.json at runtime so Hostinger can point at Coolify
 * without rebuilding the frontend bundle.
 */
export async function loadRuntimeConfig() {
    try {
        const res = await fetch('/config.json', { cache: 'no-store' });
        if (res.ok) {
            const data = (await res.json());
            cached = {
                ...BUILD_DEFAULTS,
                ...data,
                classifierApiUrl: String(data.classifierApiUrl || BUILD_DEFAULTS.classifierApiUrl).replace(/\/$/, ''),
                azureClientId: String(data.azureClientId || BUILD_DEFAULTS.azureClientId).trim(),
                azureTenantId: String(data.azureTenantId || BUILD_DEFAULTS.azureTenantId).trim(),
            };
            return cached;
        }
    }
    catch {
        /* use build defaults */
    }
    cached = { ...BUILD_DEFAULTS };
    return cached;
}
export function getClassifierApiUrl() {
    return getRuntimeConfig().classifierApiUrl.replace(/\/$/, '');
}
